import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { editUser, fetchUserById } from "../../redux/userSlice";
import { Form, Input, Button, message, Radio } from "antd";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";

const EditUser = () => {
  const { userId } = useParams(); // Get userId from route params
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { user, loading } = useSelector((state) => state.user);

  const [previewImage, setPreviewImage] = useState(null);
  const [formData, setFormData] = useState({
    house_id: "",
    name: "",
    email: "",
    phone_number: "",
    emergencyContact: "",
    lease_start_date: "",
    notes: "",
    media: null,
    status: 1,
  });

  // useEffect(() => {
  //   // Fetch user data on page load
  //   dispatch(fetchUserById(userId)).then((res) => {
  //     const fetchedUser = res.payload;
  //     setFormData({
  //       house_id: fetchedUser.house_id,
  //       name: fetchedUser.name,
  //       email: fetchedUser.email,
  //       phone_number: fetchedUser.phone_number,
  //       emergencyContact: fetchedUser.emergency_contact,
  //       lease_start_date: fetchedUser.lease_start_date,
  //       notes: fetchedUser.notes,
  //     });
  //     setPreviewImage(fetchedUser.profile_picture_url);
  //   });
  // }, [dispatch, userId]);

  const handleFormChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, media: file }));
      const reader = new FileReader();
      reader.onload = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async () => {
    const updatedData = new FormData();
    updatedData.append("house_id", formData.house_id);
    updatedData.append("name", formData.name);
    updatedData.append("email", formData.email);
    updatedData.append("phone_number", formData.phone_number);
    updatedData.append("emergency_contact", formData.emergencyContact);
    updatedData.append("notes", formData.notes);
    updatedData.append("lease_start_date", formData.lease_start_date);
    updatedData.append("status", formData.status);

    if (formData.media) updatedData.append("media", formData.media);

    try {
      await dispatch(editUser({ userId, userData: updatedData })).unwrap();
      message.success("User updated successfully!");
      navigate("/dashboard/users");
    } catch (error) {
      message.error("Failed to update user");
    }
  };

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Edit User</h1>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Form.Item label="Name">
            <Input
              value={formData.name}
              onChange={(e) => handleFormChange("name", e.target.value)}
            />
          </Form.Item>
          <Form.Item label="Email">
            <Input
              value={formData.email}
              onChange={(e) => handleFormChange("email", e.target.value)}
            />
          </Form.Item>
          <Form.Item label="Phone Number"
          rules={[
                { required: true, message: "Please enter phone number!" },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Phone number must be exactly 10 digits!",
                },
              ]}
          >
            <Input
              value={formData.phone_number}
              onChange={(e) => handleFormChange("phone_number", e.target.value)}
            />
          </Form.Item>
          <Form.Item label="Lease Start Date">
            <NepaliDatePicker
              options={{ calenderLocale: "en", valueLocale: "en" }}
              value={formData.lease_start_date}
              onChange={(date) => handleFormChange("lease_start_date", date)}
              className="w-full"
            />
          </Form.Item>
          <Form.Item label="User Image">
            {previewImage && (
              <img
                src={previewImage}
                alt="Preview"
                className="mb-4 w-40 h-40 object-cover rounded"
              />
            )}
            <Input type="file" accept="image/*" onChange={handleImageChange} />
          </Form.Item>
          <Form.Item label="Status">
            <Radio.Group
              value={formData.status}
              onChange={(e) => handleFormChange("status", e.target.value)}
            >
              <Radio value="active">Active</Radio>
              <Radio value="inactive">Inactive</Radio>
            </Radio.Group>
          </Form.Item>

          <Button type="primary" htmlType="submit" className="bg-blue-600">
            Save Changes
          </Button>
        </Form>
      )}
    </div>
  );
};

export default EditUser;
